var React = require('react');

function OutageStatusRed (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"30","height":"30","rx":"15","fill":"#D63F2F","key":0}),React.createElement("path",{"d":"M14.1809 17.207H15.818L16.1418 9H13.8409L14.1809 17.207ZM13.7495 19.777C13.7532 20.1002 13.8852 20.4092 14.1172 20.6378C14.3492 20.8663 14.6628 20.9964 14.9908 21C15.3208 20.997 15.6367 20.8677 15.8717 20.6395C16.1067 20.4113 16.2425 20.102 16.2504 19.777C16.2454 19.4498 16.111 19.1374 15.8757 18.9064C15.6405 18.6753 15.323 18.5439 14.9908 18.54C14.6606 18.5447 14.3455 18.677 14.1134 18.9084C13.8812 19.1397 13.7505 19.4517 13.7495 19.777Z","fill":"white","key":1})]);
}

OutageStatusRed.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = OutageStatusRed;

OutageStatusRed.default = OutageStatusRed;
